<template>
    <div>
        <form action="">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title has-text-white">Change Password</p>
                        <button
                            type="button"
                            class="delete"
                            @click="$emit('close')"/>
                    </header>
                    <section class="modal-card-body has-background-dvodark">
                    <button @click="goof">AAA</button>
                      <b-field horizontal label="Current Password">
                          <b-input type="password" v-model="currentPassword"></b-input>
                      </b-field>
                      <b-field horizontal label="New Password">
                          <b-input type="password" v-model="newPassword"></b-input>
                      </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button class="is-dvogreen" @click="passwordChange()">Change Password</b-button>
                    </footer>
                </div>
        </form>
    </div>
</template>


<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";
import Alert from "@/components/auth/Alert.vue";
Vue.component("v-alert", Alert);

export default {
  data() {
    return {
      currentPassword: "",
      newPassword: ""
    };
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    goof(){
    },
    async passwordChange() {
      await store.dispatch("auth/passwordChange", {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then(async () => {
          await this.$store.dispatch("auth/signOut");
          this.$parent.close()
          router.push("/");
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Password change successful, logging you out.`,
                    position: 'is-bottom',
                    type: 'is-success',
                    hasIcon: true
          })          
      }).catch((e) => {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `${e}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                    hasIcon: true
          })
      })
    }
  }
};
</script>
